export default "__VITE_ASSET__B98FlxHF__"